import { SearchOption } from '@front-app/components/search/useSearch';
import { UserSearchItem } from '@front-app/services/UserApi/UserModel';
import { ref, Ref, watch } from '@vue/composition-api';

export interface UseSelectSpeakers {
	speakerIds: Ref<string[]>;
	removeSpeaker(id: string): void;
	selectSpeaker(user: SearchOption<UserSearchItem>): void;
}

export type SpeakersSource = () => string[];

export const useSelectSpeakers = (
	source: SpeakersSource,
): UseSelectSpeakers => {
	const speakerIds: Ref<string[]> = ref([]);
	watch(source, (curr) => {
		speakerIds.value = curr;
	}, { immediate: true });
	const removeSpeaker = (id: string) => {
		speakerIds.value = speakerIds.value.filter((existing) => existing !== id);
	};
	const selectSpeaker = (user: SearchOption<UserSearchItem>) => {
		const { id } = user.original;
		if (speakerIds.value.includes(id)) {
			return;
		}
		speakerIds.value = [...speakerIds.value, id];
	};

	return {
		speakerIds,
		removeSpeaker,
		selectSpeaker,
	};
};
